<ng-template #railairtemp let-r="result" let-t="term">
  <div class="d-flex align-items-start py-2">
    @switch (r.type) { @case (locationTypes.City) {
    <i class="ico-marker me-2" aria-hidden="true"></i>
    } @case (locationTypes.Airport) {
    <i class="ico-flight me-2" aria-hidden="true"></i>
    } @case (locationTypes.TrainStation) {
    <i class="ico-rail me-2" aria-hidden="true"></i>
    } @case (locationTypes.Hotel) {
    <i class="ico-bed me-2" aria-hidden="true"></i>
    } @default {
    <i class="ico-marker me-2" aria-hidden="true"></i>
    } }
    <div>
      @let code = r.iata || (r.trainStationCode?.length <= 3 ? r.trainStationCode : '') ||
      r.countryCode;
      <span>{{ r.name }}@if(code) { ({{code}})}</span>
      @if(r.address) { - {{ r.address }} }
    </div>
  </div>
</ng-template>
<div>
  <i class="ico-marker select-box-icon" aria-hidden="true"></i>
  <input
    autocomplete="off"
    i18n-placeholder
    placeholder="Please enter an address, airport, train station, landmark or hotel"
    id="hotel-input-airport"
    (click)="$event.target.select()"
    type="text"
    appInput
    [class.error-box]="hasError"
    [attr.aria-invalid]="hasError ? 'true' : null"
    [attr.aria-describedby]="hasError ? 'error-message-list' : null"
    [(ngModel)]="model"
    (ngModelChange)="modelChanged()"
    [ngbTypeahead]="searchLocations"
    [resultTemplate]="railairtemp"
    [inputFormatter]="formatter_rail_air"
    (focus)="focus$.next($event.target.value);"
    (keyup.arrowdown)="updateElement.emit($event)"
    (keyup.arrowup)="updateElement.emit($event)"
  />
  @if (searchLocationLoading | async) {
  <i class="button_spinner input-loading-spinner-left"></i>
  }
</div>
